import { Fragment } from "react";
import { Company } from "../../../core/models/company.model";
import LinkButton from "../../buttons/LinkButton/LinkButton";

const CompanyEmailInfo = (props: { company: Company | undefined}) => {
  const { company } = props;

  if (!company?.email) {
    return <Fragment />;
  }

  const tab = () => {
    if (company?.website && company?.email)
    return (<div className="mx-1">|</div>);
  }

  return (
    <div className="info-text d-inline-flex align-items-center">
      {tab()}
      <LinkButton
        onClick={() => {}}
        styleClass="link-container"
        textClass="small"
        isMailTo={true}
        valueLink={company?.email}
        valueText={company?.email}
      />
    </div>
  );
}

export default CompanyEmailInfo;